/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeExternalProxyListResponse,
  ApiEnvelopeExternalProxyPoolDto,
  ApiEnvelopeExternalProxyPoolListResponse,
  ApiEnvelopeExternalProxyPoolProbeDto,
  ApiEnvelopeProxyBotListResponse,
  ApiEnvelopeProxyDeleteResponse,
  ApiEnvelopeProxyDirectInfoResponse,
  ApiEnvelopeProxyDto,
  ApiEnvelopeProxyHealthHistoryDto,
  ApiEnvelopeProxyListResponse,
  ApiEnvelopeReassignedBotProxyDto,
  ApiEnvelopeVotingProxySyncReportDto,
  CreateProxyRequest,
  ProxyGetHealthParams,
  SaveExternalProxyPoolRequest,
  UpdateProxyRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type proxyGetAllResponse200 = {
  data: ApiEnvelopeProxyListResponse
  status: 200
}

export type proxyGetAllResponseSuccess = (proxyGetAllResponse200) & {
  headers: Headers;
};
;

export type proxyGetAllResponse = (proxyGetAllResponseSuccess)

export const getProxyGetAllUrl = () => {




  return `/api/admin/proxies`
}

export const useProxyGetAllHook = (): ( options?: RequestInit) => Promise<proxyGetAllResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getProxyGetAllUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type proxyCreateResponse200 = {
  data: ApiEnvelopeProxyDto
  status: 200
}

export type proxyCreateResponse400 = {
  data: ApiEnvelopeProxyDto
  status: 400
}

export type proxyCreateResponse409 = {
  data: ApiEnvelopeProxyDto
  status: 409
}

export type proxyCreateResponseSuccess = (proxyCreateResponse200) & {
  headers: Headers;
};
export type proxyCreateResponseError = (proxyCreateResponse400 | proxyCreateResponse409) & {
  headers: Headers;
};

export type proxyCreateResponse = (proxyCreateResponseSuccess | proxyCreateResponseError)

export const getProxyCreateUrl = () => {




  return `/api/admin/proxies`
}

export const useProxyCreateHook = (): (createProxyRequest?: CreateProxyRequest, options?: RequestInit) => Promise<proxyCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (createProxyRequest?: CreateProxyRequest, options?: RequestInit) => {

        return customFetcher(getProxyCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProxyRequest)
  }
);
      }
  }


export type proxyGetDirectInfoResponse200 = {
  data: ApiEnvelopeProxyDirectInfoResponse
  status: 200
}

export type proxyGetDirectInfoResponseSuccess = (proxyGetDirectInfoResponse200) & {
  headers: Headers;
};
;

export type proxyGetDirectInfoResponse = (proxyGetDirectInfoResponseSuccess)

export const getProxyGetDirectInfoUrl = () => {




  return `/api/admin/proxies/direct`
}

export const useProxyGetDirectInfoHook = (): ( options?: RequestInit) => Promise<proxyGetDirectInfoResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getProxyGetDirectInfoUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type proxyGetExternalResponse200 = {
  data: ApiEnvelopeExternalProxyListResponse
  status: 200
}

export type proxyGetExternalResponseSuccess = (proxyGetExternalResponse200) & {
  headers: Headers;
};
;

export type proxyGetExternalResponse = (proxyGetExternalResponseSuccess)

export const getProxyGetExternalUrl = () => {




  return `/api/admin/proxies/external`
}

export const useProxyGetExternalHook = (): ( options?: RequestInit) => Promise<proxyGetExternalResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getProxyGetExternalUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type proxyGetBotsResponse200 = {
  data: ApiEnvelopeProxyBotListResponse
  status: 200
}

export type proxyGetBotsResponseSuccess = (proxyGetBotsResponse200) & {
  headers: Headers;
};
;

export type proxyGetBotsResponse = (proxyGetBotsResponseSuccess)

export const getProxyGetBotsUrl = () => {




  return `/api/admin/proxies/bots`
}

export const useProxyGetBotsHook = (): ( options?: RequestInit) => Promise<proxyGetBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getProxyGetBotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type proxyReassignBotResponse200 = {
  data: ApiEnvelopeReassignedBotProxyDto
  status: 200
}

export type proxyReassignBotResponse400 = {
  data: ApiEnvelopeReassignedBotProxyDto
  status: 400
}

export type proxyReassignBotResponse401 = {
  data: ApiEnvelopeReassignedBotProxyDto
  status: 401
}

export type proxyReassignBotResponse403 = {
  data: ApiEnvelopeReassignedBotProxyDto
  status: 403
}

export type proxyReassignBotResponseSuccess = (proxyReassignBotResponse200) & {
  headers: Headers;
};
export type proxyReassignBotResponseError = (proxyReassignBotResponse400 | proxyReassignBotResponse401 | proxyReassignBotResponse403) & {
  headers: Headers;
};

export type proxyReassignBotResponse = (proxyReassignBotResponseSuccess | proxyReassignBotResponseError)

export const getProxyReassignBotUrl = (botId: string,) => {




  return `/api/admin/proxies/bots/${botId}/reassign`
}

export const useProxyReassignBotHook = (): (botId: string, options?: RequestInit) => Promise<proxyReassignBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getProxyReassignBotUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type proxyGetHealthResponse200 = {
  data: ApiEnvelopeProxyHealthHistoryDto
  status: 200
}

export type proxyGetHealthResponseSuccess = (proxyGetHealthResponse200) & {
  headers: Headers;
};
;

export type proxyGetHealthResponse = (proxyGetHealthResponseSuccess)

export const getProxyGetHealthUrl = (id: string,
    params?: ProxyGetHealthParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/proxies/${id}/health?${stringifiedParams}` : `/api/admin/proxies/${id}/health`
}

export const useProxyGetHealthHook = (): (id: string,
    params?: ProxyGetHealthParams, options?: RequestInit) => Promise<proxyGetHealthResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: ProxyGetHealthParams, options?: RequestInit) => {

        return customFetcher(getProxyGetHealthUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type proxyGetResponse200 = {
  data: ApiEnvelopeProxyDto
  status: 200
}

export type proxyGetResponse404 = {
  data: ApiEnvelopeProxyDto
  status: 404
}

export type proxyGetResponseSuccess = (proxyGetResponse200) & {
  headers: Headers;
};
export type proxyGetResponseError = (proxyGetResponse404) & {
  headers: Headers;
};

export type proxyGetResponse = (proxyGetResponseSuccess | proxyGetResponseError)

export const getProxyGetUrl = (id: string,) => {




  return `/api/admin/proxies/${id}`
}

export const useProxyGetHook = (): (id: string, options?: RequestInit) => Promise<proxyGetResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getProxyGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type proxyUpdateResponse200 = {
  data: ApiEnvelopeProxyDto
  status: 200
}

export type proxyUpdateResponse400 = {
  data: ApiEnvelopeProxyDto
  status: 400
}

export type proxyUpdateResponse404 = {
  data: ApiEnvelopeProxyDto
  status: 404
}

export type proxyUpdateResponse409 = {
  data: ApiEnvelopeProxyDto
  status: 409
}

export type proxyUpdateResponseSuccess = (proxyUpdateResponse200) & {
  headers: Headers;
};
export type proxyUpdateResponseError = (proxyUpdateResponse400 | proxyUpdateResponse404 | proxyUpdateResponse409) & {
  headers: Headers;
};

export type proxyUpdateResponse = (proxyUpdateResponseSuccess | proxyUpdateResponseError)

export const getProxyUpdateUrl = (id: string,) => {




  return `/api/admin/proxies/${id}`
}

export const useProxyUpdateHook = (): (id: string,
    updateProxyRequest?: UpdateProxyRequest, options?: RequestInit) => Promise<proxyUpdateResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    updateProxyRequest?: UpdateProxyRequest, options?: RequestInit) => {

        return customFetcher(getProxyUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProxyRequest)
  }
);
      }
  }


export type proxyDeleteResponse200 = {
  data: ApiEnvelopeProxyDeleteResponse
  status: 200
}

export type proxyDeleteResponse404 = {
  data: ApiEnvelopeProxyDeleteResponse
  status: 404
}

export type proxyDeleteResponseSuccess = (proxyDeleteResponse200) & {
  headers: Headers;
};
export type proxyDeleteResponseError = (proxyDeleteResponse404) & {
  headers: Headers;
};

export type proxyDeleteResponse = (proxyDeleteResponseSuccess | proxyDeleteResponseError)

export const getProxyDeleteUrl = (id: string,) => {




  return `/api/admin/proxies/${id}`
}

export const useProxyDeleteHook = (): (id: string, options?: RequestInit) => Promise<proxyDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getProxyDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type proxyGetPoolsResponse200 = {
  data: ApiEnvelopeExternalProxyPoolListResponse
  status: 200
}

export type proxyGetPoolsResponseSuccess = (proxyGetPoolsResponse200) & {
  headers: Headers;
};
;

export type proxyGetPoolsResponse = (proxyGetPoolsResponseSuccess)

export const getProxyGetPoolsUrl = () => {




  return `/api/admin/proxies/pools`
}

export const useProxyGetPoolsHook = (): ( options?: RequestInit) => Promise<proxyGetPoolsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getProxyGetPoolsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type proxyCreatePoolResponse200 = {
  data: ApiEnvelopeExternalProxyPoolDto
  status: 200
}

export type proxyCreatePoolResponse400 = {
  data: ApiEnvelopeExternalProxyPoolDto
  status: 400
}

export type proxyCreatePoolResponse409 = {
  data: ApiEnvelopeExternalProxyPoolDto
  status: 409
}

export type proxyCreatePoolResponseSuccess = (proxyCreatePoolResponse200) & {
  headers: Headers;
};
export type proxyCreatePoolResponseError = (proxyCreatePoolResponse400 | proxyCreatePoolResponse409) & {
  headers: Headers;
};

export type proxyCreatePoolResponse = (proxyCreatePoolResponseSuccess | proxyCreatePoolResponseError)

export const getProxyCreatePoolUrl = () => {




  return `/api/admin/proxies/pools`
}

export const useProxyCreatePoolHook = (): (saveExternalProxyPoolRequest?: SaveExternalProxyPoolRequest, options?: RequestInit) => Promise<proxyCreatePoolResponse> => {

      const customFetcher = useSfetchMutator();
      return (saveExternalProxyPoolRequest?: SaveExternalProxyPoolRequest, options?: RequestInit) => {

        return customFetcher(getProxyCreatePoolUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveExternalProxyPoolRequest)
  }
);
      }
  }


export type proxyUpdatePoolResponse200 = {
  data: ApiEnvelopeExternalProxyPoolDto
  status: 200
}

export type proxyUpdatePoolResponse400 = {
  data: ApiEnvelopeExternalProxyPoolDto
  status: 400
}

export type proxyUpdatePoolResponse404 = {
  data: ApiEnvelopeExternalProxyPoolDto
  status: 404
}

export type proxyUpdatePoolResponse409 = {
  data: ApiEnvelopeExternalProxyPoolDto
  status: 409
}

export type proxyUpdatePoolResponseSuccess = (proxyUpdatePoolResponse200) & {
  headers: Headers;
};
export type proxyUpdatePoolResponseError = (proxyUpdatePoolResponse400 | proxyUpdatePoolResponse404 | proxyUpdatePoolResponse409) & {
  headers: Headers;
};

export type proxyUpdatePoolResponse = (proxyUpdatePoolResponseSuccess | proxyUpdatePoolResponseError)

export const getProxyUpdatePoolUrl = (id: string,) => {




  return `/api/admin/proxies/pools/${id}`
}

export const useProxyUpdatePoolHook = (): (id: string,
    saveExternalProxyPoolRequest?: SaveExternalProxyPoolRequest, options?: RequestInit) => Promise<proxyUpdatePoolResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    saveExternalProxyPoolRequest?: SaveExternalProxyPoolRequest, options?: RequestInit) => {

        return customFetcher(getProxyUpdatePoolUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveExternalProxyPoolRequest)
  }
);
      }
  }


export type proxyDeletePoolResponse200 = {
  data: ApiEnvelopeProxyDeleteResponse
  status: 200
}

export type proxyDeletePoolResponse400 = {
  data: ApiEnvelopeProxyDeleteResponse
  status: 400
}

export type proxyDeletePoolResponse404 = {
  data: ApiEnvelopeProxyDeleteResponse
  status: 404
}

export type proxyDeletePoolResponseSuccess = (proxyDeletePoolResponse200) & {
  headers: Headers;
};
export type proxyDeletePoolResponseError = (proxyDeletePoolResponse400 | proxyDeletePoolResponse404) & {
  headers: Headers;
};

export type proxyDeletePoolResponse = (proxyDeletePoolResponseSuccess | proxyDeletePoolResponseError)

export const getProxyDeletePoolUrl = (id: string,) => {




  return `/api/admin/proxies/pools/${id}`
}

export const useProxyDeletePoolHook = (): (id: string, options?: RequestInit) => Promise<proxyDeletePoolResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getProxyDeletePoolUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type proxySyncPoolResponse200 = {
  data: ApiEnvelopeVotingProxySyncReportDto
  status: 200
}

export type proxySyncPoolResponse400 = {
  data: ApiEnvelopeVotingProxySyncReportDto
  status: 400
}

export type proxySyncPoolResponseSuccess = (proxySyncPoolResponse200) & {
  headers: Headers;
};
export type proxySyncPoolResponseError = (proxySyncPoolResponse400) & {
  headers: Headers;
};

export type proxySyncPoolResponse = (proxySyncPoolResponseSuccess | proxySyncPoolResponseError)

export const getProxySyncPoolUrl = (id: string,) => {




  return `/api/admin/proxies/pools/${id}/sync`
}

export const useProxySyncPoolHook = (): (id: string, options?: RequestInit) => Promise<proxySyncPoolResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getProxySyncPoolUrl(id),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type proxyTestPoolResponse200 = {
  data: ApiEnvelopeExternalProxyPoolProbeDto
  status: 200
}

export type proxyTestPoolResponse400 = {
  data: ApiEnvelopeExternalProxyPoolProbeDto
  status: 400
}

export type proxyTestPoolResponseSuccess = (proxyTestPoolResponse200) & {
  headers: Headers;
};
export type proxyTestPoolResponseError = (proxyTestPoolResponse400) & {
  headers: Headers;
};

export type proxyTestPoolResponse = (proxyTestPoolResponseSuccess | proxyTestPoolResponseError)

export const getProxyTestPoolUrl = (id: string,) => {




  return `/api/admin/proxies/pools/${id}/test`
}

export const useProxyTestPoolHook = (): (id: string, options?: RequestInit) => Promise<proxyTestPoolResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getProxyTestPoolUrl(id),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


